import type { AppTextColor } from '@shared/ui/typography'

import { TasksKanbanStage } from '@brighterly/lib-core-types/tasks-kanban/enums'

export const TASKS_KANBAN_STAGE_TEXT_COLOR: Record<TasksKanbanStage, AppTextColor> = {
  [TasksKanbanStage.Backlog]: 'slate-500',
  [TasksKanbanStage.Todo]: 'blue-600',
  [TasksKanbanStage.InProgress]: 'blue-600',
  [TasksKanbanStage.Waiting]: 'orange-600',
  [TasksKanbanStage.Resolved]: 'emerald-500',
  [TasksKanbanStage.Cancelled]: 'red-500',
}
